import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    flex: {
      display: 'flex',
      alignItems: 'center',
    },
    total: {
      fontSize: 12,
      fontWeight: 400,
      color: theme.palette.colors.gray4_5,
      marginLeft: theme.spacing(2),
    },
    newStyle: {
      background: '#F5F8FA',
      borderRadius: 20,
      maxHeight: 35,
      height: '100%',
      marginLeft: -8,
      '& div': {
        maxHeight: 35,
        '& fieldset': {
          border: 'none',
        },
        '&:focus-within': {
          '& fieldset': {
            border: 'solid 1px #249eb2',
            borderRadius: 20,
          },
        },
      },
    },
  }),
);

export default useStyles;
